import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Chip,
  Grid,
  Typography,
} from '@mui/material';
import { ContactEmergency, DirectionsWalk } from '@mui/icons-material';
import InputMask from 'react-input-mask';
import JumboTextField from '@jumbo/components/JumboFormik/JumboTextField';

const ContatoCard = ({
  numero,
  values,
  handleChange,
  tipo = 'emergencia',
  obrigatorio = false,
}) => {
  const prefixo = tipo === 'emergencia' ? 'contato_emergencia' : 'autorizado';
  const icon =
    tipo === 'emergencia' ? <ContactEmergency /> : <DirectionsWalk />;
  const titulo =
    tipo === 'emergencia'
      ? 'Contato de Emergência'
      : 'Pessoa Autorizada a Buscar';

  return (
    <Card
      variant='outlined'
      sx={{
        mb: 2,
        border: obrigatorio ? 2 : 1,
        borderColor: obrigatorio ? 'error.light' : 'divider',
      }}
    >
      <CardContent>
        <Box display='flex' alignItems='center' gap={1} mb={2}>
          {icon}
          <Typography variant='h6' sx={{ fontWeight: 600 }}>
            {titulo} {numero}{' '}
            {obrigatorio && (
              <Chip
                label='Obrigatório'
                size='small'
                color='error'
                sx={{ ml: 1 }}
              />
            )}
          </Typography>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <JumboTextField
              fullWidth
              name={`${prefixo}_${numero}_nome`}
              label={`Nome Completo${obrigatorio ? ' *' : ''}`}
              placeholder='Digite o nome completo'
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <JumboTextField
              fullWidth
              name={`${prefixo}_${numero}_parentesco`}
              label='Parentesco ou Relação'
              placeholder='Ex: Tia, Avó, Amigo da família'
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputMask
              mask='+999(99)99999-9999'
              value={values[`${prefixo}_${numero}_celular`]}
              onChange={handleChange}
            >
              {(inputProps) => (
                <JumboTextField
                  {...inputProps}
                  fullWidth
                  name={`${prefixo}_${numero}_celular`}
                  label={`Celular${obrigatorio ? ' *' : ''}`}
                  placeholder='+55(00)00000-0000'
                />
              )}
            </InputMask>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ContatoCard;
